import classNames from 'classnames';
import { useTranslation } from 'react-i18next';
import { PiCheckCircleFill, PiCircleFill, PiPlus, PiUser } from 'react-icons/pi';
import './AccountSwichSearchCard.scss';

interface IAccountSearchCardProps {
  account?: {
    id: string;
    label: string;
    labelName?: string | null;
    photoLink?: string | null;
  };

  isSelected?: boolean;
  onClick?: (account?: {
    id: string;
    labelName?: string | null;
    photoLink?: string | null;
  }) => void;
}

const AccountSearchCard = ({ account, isSelected, onClick }: IAccountSearchCardProps) => {
  const { t } = useTranslation();
  return (
    <div
      className={classNames(['account-search-card'], { isSelected })}
      onClick={() => onClick && onClick(account)}
    >
      <div className="account-search-card-profile">
        {account?.photoLink ? <img src={account.photoLink} /> : account ? <PiUser /> : <PiPlus />}
      </div>

      <div className="account-search-card-header">
        <div className="account-search-card-header-title">
          {account?.labelName ?? t('button.add-new-account')}
        </div>
      </div>
      {account && <>{isSelected ? <PiCheckCircleFill /> : <PiCircleFill />}</>}
    </div>
  );
};

export default AccountSearchCard;
